import PropTypes from "prop-types";
import "./ProjectMedia.scss";

const initials = (name) =>
  name
    .replace(/[^A-Za-z0-9 ]/g, " ")
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((w) => w[0].toUpperCase())
    .join("");

/**
 * Neutral, CSS-only phone mockup used when a project has no local screenshot.
 * Deliberately abstract: it shows the app name, never fake UI content.
 */
export const DeviceMockup = ({ name, category }) => (
  <div
    className="device-mockup"
    role="img"
    aria-label={`Placeholder illustration for ${name}. No screenshot available.`}
  >
    <div className="device-mockup__phone">
      <div className="device-mockup__notch" />
      <div className="device-mockup__screen">
        <span className="device-mockup__mark">{initials(name)}</span>
        <span className="device-mockup__name">{name}</span>
        <span className="device-mockup__category">{category}</span>
        <span className="device-mockup__bars">
          <i />
          <i />
          <i />
        </span>
      </div>
    </div>
  </div>
);

DeviceMockup.propTypes = {
  name: PropTypes.string.isRequired,
  category: PropTypes.string,
};

const ProjectMedia = ({ project, variant = "card", eager = false }) => (
  <div
    className={`project-media project-media--${variant}${
      project.image ? "" : " project-media--placeholder"
    }`}
  >
    {project.image ? (
      <img
        src={project.image}
        alt={project.imageAlt}
        loading={eager ? "eager" : "lazy"}
        decoding="async"
      />
    ) : (
      <DeviceMockup name={project.name} category={project.category} />
    )}
  </div>
);

ProjectMedia.propTypes = {
  project: PropTypes.object.isRequired,
  variant: PropTypes.oneOf(["card", "hero"]),
  eager: PropTypes.bool,
};

export default ProjectMedia;
